import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

// material-ui
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import { useTheme } from '@mui/material/styles';
import { Button, ButtonBase, Divider, Grid, Stack, Typography, useMediaQuery } from '@mui/material';

// project imports
import MainCard from '../MainCard';

// assets
import { ApartmentOutlined, HomeFilled, HomeOutlined } from '@ant-design/icons';
import useMain from 'hooks/useMain';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

// ==============================|| BREADCRUMBS ||============================== //

const Breadcrumbs = ({
  card,
  divider = true,
  icon,
  icons,
  maxItems,
  navigation,
  rightAlign,
  separator,
  title,
  titleBottom,
  sx,
  ...others
}) => {
  const theme = useTheme();
  const { t, useSelector, useNavigate, rowSelected } = useMain();
  const navigate = useNavigate();
  const location = useLocation();
  const [main, setMain] = useState();
  const [item, setItem] = useState();
  const leftMenu = useSelector((state) => state.menu.formattedLeftMenu);
  const RfidtagNo = location?.state?.rfidtagNo;
  const matchesSM = useMediaQuery(theme.breakpoints.down('md'));

  const targetLeftMenu = leftMenu.find(({ url }) => location.pathname.includes(url));
  const iconSX = {
    marginRight: theme.spacing(0.75),
    marginTop: `-${theme.spacing(0.25)}`,
    width: '1rem',
    height: '1rem',
    color: theme.palette.secondary.main
  };

  // set active item state
  const getCollapse = (menu) => {
    if (menu.children) {
      menu.children.filter((collapse) => {
        if (collapse.type && collapse.type === 'collapse') {
          getCollapse(collapse);
        } else if (collapse.type && collapse.type === 'item') {
          if (location.pathname.includes(collapse.url)) {
            setMain(menu);
            setItem(collapse);
          }
        }
        return false;
      });
    }
  };

  useEffect(() => {
    [targetLeftMenu].map((menu) => {
      if (menu?.type && menu.type === 'group') {
        getCollapse(menu);
      }
      return false;
    });
    return () => setItem();
  });

  // only used for component demo breadcrumbs
  if (location.pathname === '/components-overview/breadcrumbs') {
    location.pathname = '/dashboard/analytics';
  }

  // item separator
  const SeparatorIcon = separator;
  const separatorIcon = separator ? <SeparatorIcon style={{ fontSize: '0.75rem', marginTop: 2 }} /> : '/';

  let mainContent;
  let itemContent;
  let breadcrumbContent = <Typography />;
  let itemTitle = '';
  let CollapseIcon;
  let ItemIcon;

  const isDetail =
    location.pathname.includes('detail') ||
    location.pathname.includes('import') ||
    location.pathname.includes('batch') ||
    location.pathname.includes('profile');
  const isBatchUpdate = location.pathname.includes('batchUpdate');

  // collapse item
  // if (main && main.type === 'collapse') {
  //   CollapseIcon = main.icon ? main.icon : ApartmentOutlined;
  //   mainContent = (
  //     <Typography component={Link} to={document.location.pathname} variant="h6" sx={{ textDecoration: 'none' }} color="textSecondary">
  //       {icons && <CollapseIcon style={iconSX} />}
  //       {main.title}
  //     </Typography>
  //   );
  // }

  // items
  if (item && item.type === 'item') {
    itemTitle = item.title;

    ItemIcon = item.icon ? item.icon : ApartmentOutlined;
    itemContent = (
      // added theme color
      <Typography component={Link} to={item.url} variant="subtitle1" color={theme.palette.primary[400]}>
        {icons && <ItemIcon style={iconSX} />}
        {t(itemTitle)}
      </Typography>
    );
    // main
    if (item.breadcrumbs !== false) {
      breadcrumbContent = (
        <MainCard
          border={card}
          sx={card === false ? { mb: 1, bgcolor: 'transparent', ...sx } : { mb: 3, ...sx }}
          {...others}
          content={card}
          shadow="none"
        >
          <Grid
            container
            direction={rightAlign ? 'row' : 'column'}
            justifyContent={rightAlign ? 'space-between' : 'flex-start'}
            alignItems={rightAlign ? 'center' : 'flex-start'}
            spacing={1}
          >
            {title && !titleBottom && (
              <Grid item>
                <Typography variant="h2">{t(itemTitle)}</Typography>
              </Grid>
            )}
            <Grid item>
              {/* disable breadcrumb on detail */}
              {!isDetail && (
                <MuiBreadcrumbs aria-label="breadcrumb" maxItems={maxItems || 8} separator={separatorIcon}>
                  <Typography component={Link} to="/dashboard" color="textSecondary" variant="h6" sx={{ textDecoration: 'none' }}>
                    {icons && <HomeOutlined style={iconSX} />}
                    {icon && !icons && <HomeFilled style={{ ...iconSX, marginRight: 0 }} />}
                    {(!icon || icons) && t('HOME')}
                  </Typography>
                  {mainContent}
                  {itemContent}
                  {isDetail && (
                    <Typography variant="subtitle1" color="textSecondary">
                      {icons && <ItemIcon style={iconSX} />}
                      {t('DETAIL')}
                    </Typography>
                  )}
                </MuiBreadcrumbs>
              )}
            </Grid>
            {title && titleBottom && (
              <Grid item sx={{ mt: card === false ? 0.25 : 1 }} width="100%">
                <Stack flexDirection="row" justifyContent="flex-start" alignItems="center" ml={isDetail && 2}>
                  {' '}
                  {isDetail && (
                    <ButtonBase onClick={() => navigate(-1)}>
                      <ArrowBackIosIcon />
                    </ButtonBase>
                  )}
                  <Stack direction={matchesSM ? 'column' : 'row'} alignItems={matchesSM ? 'flex-start' : 'flex-end'}>
                    <Typography variant="h4">{t(itemTitle)}</Typography>{' '}
                    {isBatchUpdate && (
                      <Typography color={theme.palette.primary[400]}>{t('ROWS_COUNT', { ROWSCOUNT: rowSelected })}</Typography>
                    )}
                    {RfidtagNo && !isBatchUpdate && (
                      <Typography ml={!matchesSM && 1} color={theme.palette.primary[400]}>
                        ID: {RfidtagNo}
                      </Typography>
                    )}
                  </Stack>
                  {/* {isDetail && (
                    <Button variant="contained" onClick={() => navigate(-1)}>
                      <X />
                    </Button>
                  )} */}
                </Stack>
              </Grid>
            )}
          </Grid>
          {card === false && divider !== false && <Divider sx={{ mt: 2 }} />}
        </MainCard>
      );
    }
  }

  return breadcrumbContent;
};

Breadcrumbs.propTypes = {
  card: PropTypes.bool,
  divider: PropTypes.bool,
  icon: PropTypes.bool,
  icons: PropTypes.bool,
  maxItems: PropTypes.number,
  rightAlign: PropTypes.bool,
  separator: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  title: PropTypes.bool,
  titleBottom: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};

export default Breadcrumbs;
